import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string'
import * as actions from '../../actions'
import {success, error} from '../../components/common/toast'
import Loading from '../common/loading'
import LoginFooter from './loginFooter';
import LoginHeader from './loginHeader';
import giftBox from '../../assets/gift-box.png'

function Referral(props) {
    // const [gifterName, setGifterName] = useState()
    // const [gifterEmail, setGifterEmail] = useState()
    // const [recipientName, setRecipientName] = useState()
    // const [recipientEmail, setRecipientEmail] = useState()
    const [state, setState] = useState({})

    useEffect(() => {
        if (props.location.search) {
            const parsed = queryString.parse(props.location.search)
            setState({...state, gifterName: parsed.name, gifterEmail: parsed.email})
        }
    }, [props.location.search])

    const handleChange = (e) => {
        setState({...state, [e.target.name]: e.target.value});
    }

    const submitForm = (e) => {
        e.preventDefault()
        props.makeReferral(state)
        // Promise.resolve()
        .then(() => {
            window.location.href ='/'
        })
    }

    return <div className='login-wrapper'>
        <LoginHeader {...props} />
        <div className='referral'>
            <img src={giftBox}/>
            <div className='referral-text-block'>
                <span className='login-title'>Refer a friend</span>
                <br/>
                <span className='login-text'>Refer your friends to Dialog. If they join we'll give them a month on us (and we'll give it to you too)!</span>
                <div className='referral-panel'>
                    <div className='input-block'>
                        <label>Your Name</label>
                        <input name='gifterName' className='login-control' value={state.gifterName ?? ''} onChange={handleChange} placeholder='Eg. John Smith' />
                    </div>
                    <div className='input-block'>
                        <label>Your Email Address</label>
                        <input name='gifterEmail' className='login-control' value={state.gifterEmail ?? ''} onChange={handleChange} placeholder='Eg. example@email.com' />
                    </div>
                    <div className='input-block'>
                        <label>Your Friend's Name</label>
                        <input name='recipientName' className='login-control' value={state.recipientName ?? ''} onChange={handleChange} placeholder='Eg. John Smith' />
                    </div>
                    <div className='input-block'>
                        <label>Their Email Address</label>
                        <input name='recipientEmail' className='login-control' value={state.recipientEmail ?? ''} onChange={handleChange} placeholder='Eg. example@email.com' />
                    </div>
                    <button className='btn btn-primary login-control' style={{width: 'fit-content'}} onClick={submitForm}>Submit</button>
                </div>
            </div>
            <Loading />
        </div>
        <LoginFooter />
    </div>
}

export default connect(null, actions)(Referral)